module.exports = __webpack_public_path__ + "img/vector.66985899.png";